import { useState } from 'react';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { Wallet, ShieldCheck, Smartphone, Users, Loader2 } from 'lucide-react';

const FEATURES = [
  { icon: ShieldCheck, text: 'Acceso seguro con Google Workspace' },
  { icon: Smartphone,  text: 'Funciona sin conexión en móvil y escritorio' },
  { icon: Users,       text: 'Finanzas compartidas con tu familia' },
];

export default function LoginPage({ auth }) {
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      const provider = new GoogleAuthProvider();
      // Request directory.readonly so Settings can search Workspace users
      provider.addScope('https://www.googleapis.com/auth/directory.readonly');
      provider.setCustomParameters({ prompt: 'select_account' });
      const result = await signInWithPopup(auth, provider);
      // Store Google access token for Workspace directory queries
      const credential = GoogleAuthProvider.credentialFromResult(result);
      if (credential?.accessToken) {
        sessionStorage.setItem('gAccessToken', credential.accessToken);
      }
      // Access check (registered in users collection) happens in App.jsx
    } catch (err) {
      if (err.code === 'auth/popup-closed-by-user') {
        setError('');
      } else {
        setError('No se pudo iniciar sesión. Verifica tu cuenta e inténtalo de nuevo.');
        console.error('Login error:', err);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <Wallet size={60} className="login-icon" />
        <h1>Takiro's Finances</h1>
        <p className="login-subtitle">Gestiona el presupuesto familiar</p>

        {error && (
          <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '0.5rem', padding: '0.75rem 1rem', marginBottom: '1rem', fontSize: '0.85rem', color: '#dc2626', textAlign: 'left', lineHeight: 1.4 }}>
            {error}
          </div>
        )}

        <button className="btn-google-login" onClick={handleGoogleLogin} disabled={loading}>
          {loading ? (
            <Loader2 size={20} style={{ animation: 'spin 1s linear infinite' }} />
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
          )}
          {loading ? 'Iniciando sesión...' : 'Iniciar sesión con Google'}
        </button>

        <p className="login-note">Solo cuentas autorizadas por el administrador tienen acceso.</p>

        <div className="login-features">
          {FEATURES.map(({ icon: Icon, text }) => (
            <div key={text} className="feature">
              <Icon size={20} style={{ color: '#1a472a', flexShrink: 0 }} />
              <p>{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
